export default __webpack_public_path__ + "static/media/app-store.a4f52643.png";